import request from '@/utils/request'
import URL from '@/api/urlTranslator'

// 列表
export function getBusinessCommissionFunc(requestBody) {
  return request({
    url: URL.finance.accountingEntry.getBusinessCommissionUrl,
    method: 'post',
    data: requestBody
  })
}

